export default "__VITE_ASSET__CQZRb3gv__"